// Need to use the React-specific entry point to import createApi
import { baseApi } from "./baseApi";

// using CSRF token from Local Storage

// Define a service using a base URL and expected endpoints
export const disputeApi = baseApi.injectEndpoints({
  reducerPath: "disputeApi",
  endpoints: (builder) => ({
    getAllDisputes: builder.query({
      query: ({ limit, page }) => {
        return {
          url: `admin/dispute?&page=${page}&limit=${limit}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
    resolveDispute: builder.mutation({
      query: (id) => {
        return {
          url: `admin/dispute/resolved/${id}`,
          method: "PUT",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      // invalidatesTags: ['User'],
    }),
    getDisputeReasons: builder.query({
      query: ({ limit, page }) => {
        return {
          url: `admin/dispute-reason?&page=${page}&limit=${limit}`,
          method: "GET",
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
      keepUnusedDataFor: 0,
      refetchOnFocus: true,
      // providesTags: ['User'],
    }),
    disputeReason: builder.mutation({
        query: (data) => {
            console.log(data);
          return {
            url: `admin/dispute-reason/${data?.id}`,
            method: "PUT",
            body: data,
            headers: {
              "Content-type": "application/json; charset=UTF-8",
            },
          };
        },
        // invalidatesTags: ['User'],
      }),
    resolveDepositEscrow: builder.mutation({
      query: (data) => {
        return {
          url: "admin/payment/resolve-deposit",
          method: "POST",
          body: data,
          headers: {
            "Content-type": "application/json; charset=UTF-8",
          },
        };
      },
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetAllDisputesQuery,
  useResolveDisputeMutation,
  useGetDisputeReasonsQuery,
  useDisputeReasonMutation,
  useResolveDepositEscrowMutation,
} = disputeApi;
